@if (actionGroups && actionGroups.length > 0) {
  <div>
    <button mat-button (click)="isOpen = !isOpen" type="button" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
      <mat-icon aria-hidden="false" aria-label="Example home icon">more_vert</mat-icon>
      <span style="font-size: 16px; padding-left: 4px">Actions</span>
    </button>
    <!-- This template displays the overlay content and is connected to the button -->
    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayOrigin]="trigger"
      [cdkConnectedOverlayOpen]="isOpen"
      (backdropClick)="isOpen = !isOpen"
      [cdkConnectedOverlayHasBackdrop]="true">
      <div class="overlay-content">
        <div class="tab-group-label">
          Actions
          <mat-divider></mat-divider>
        </div>
        @for (item of actionGroups; track item) {
          <div>
            <div>{{ item.name }}</div>
            <ul>
              @if (menuConfig.code === 'players' && item.name === 'Money operation') {
                <li>
                  <app-app-wallet-manual-adjustment [playerId]="headerData.id"></app-app-wallet-manual-adjustment>
                </li>
              }
              @for (action of item.items; track action) {
                <li>
                  <app-action [simple]="true" [actionConfig]="action" [data]="headerData"></app-action>
                </li>
              }
            </ul>
          </div>
        }
      </div>
    </ng-template>
  </div>
}
